module.exports = __webpack_public_path__ + "static/assets/d1b2943e1c6ba22f7344457c7bb96563.svg";